// src/components/ui/PageShell.jsx

import React from 'react';
import { PAGE } from './pageTheme';

export default function PageShell({ children, style }) {
  return (
    <div
      style={{
        height: '100%',
        minHeight: 0,
        background: PAGE.colors.bg,
        overflow: 'hidden',
        boxSizing: 'border-box',
        fontFamily: PAGE.fontFamily,
        ...style,
      }}
    >
      <div
        style={{
          height: '100%',
          minHeight: 0,
          maxWidth: PAGE.maxWidth,
          margin: '0 auto',
          padding: `${PAGE.paddingY}px ${PAGE.paddingX}px`,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          gap: PAGE.gap,
          overflow: 'hidden',
        }}
      >
        {children}
      </div>
    </div>
  );
}
